
import { defineComponent } from 'vue'
import networkGraph from "@/components/networkGraph.vue";

export default defineComponent({
  name: 'App',

  components: {
    networkGraph
  },

  data () {
    return {
      //
    }
  },
})
